import React, { useState, useEffect, useContext } from "react";
import OtpInputBox from "./OtpInputBox";
import TMSlogo from "../../../../assets/CreditCheckOTP/img/tms-legal-logo.png";
import SecurityImg from "../../../../assets/CreditCheckOTP/img/security-1.png";
import SecureLabel from "../../../../assets/CreditCheckOTP/img/100%-secure.png";
import "../../../../assets/CreditCheckOTP/css/modules/custom.scss";
import "../../../../assets/CreditCheckOTP/css/modules/otp.scss";
import OTPSuccess from "./OTPSuccess";
import OTPFail from "./OTPFail";
import ReferenceContext from "../../../../Contexts/ReferenceContext";
import VisitorParamsContext from "../../../../Contexts/VisitorParams";
import { useGetCreditAnalysisDataV2 } from "../../../../Hooks/useGetCreditAnalysisDataV2";
import { useHistory } from "react-router-dom";
import { useSkippedLeads } from '../../../../Hooks/useSkippedLeads';
import { Api } from "../../../../api/Api";

const CreditCheck_OTP_flp = () => {


    const [otp, setOTP] = useState("");
    const [otpshow, setOtpshow] = useState(true);
    const [isValid, setIsValid] = useState(false);
    const [isInvalid, setIsInvalid] = useState(false);
    const [timeRemaining, setTimeRemaining] = useState(60);
    const [resendDiv, setResendDiv] = useState(false);
    const [error, setError] = useState(false);
    const { referenceID } = useContext(ReferenceContext);
    const { getCreditAnalysisDataV2 } = useGetCreditAnalysisDataV2();
    const { visitorParameters } = useContext(VisitorParamsContext);
    // const formData = JSON.parse(localStorage.getItem("formData")) || {};
    const stored = localStorage.getItem("formData");
    const formData = stored ? JSON.parse(stored) : {};
    const query = new URLSearchParams(window.location.search);
    const uuid = query.get("uuid");
    const history = useHistory();
    const [btnDisabled, setBtnDisabled] = useState(false);
    const { skippedLeads } = useSkippedLeads();
    const redirectUrl = `/credit_check_confirm_flp?uuid=${uuid}`;

    // Query string for followup
    const queryFlp = window.location.search.substring(1); // removes '?'
    const queryString = queryFlp.replace(/(^|&)uuid=[^&]*&?/, '').replace(/&$/, '');
    console.log("queryString FLP", queryString);

    useEffect(() => {
        const getStoredFormData = () => {
            try {
                const data = localStorage.getItem("formData");
                return data ? JSON.parse(data) : null;
            } catch (error) {
                console.error("Error parsing formData from localStorage:", error);
                return null;
            }
        };
    
        const fetchDataFromAPI = async () => {
            try {
                const response = await Api.get(
                    `/api/v1/followup/get-details-otp?query_string=${queryString}`
                );
    
                if (response.data && response.data.status === "Success") {
                    const data = response.data.response;
    
                    const updatedFormData = {
                        userId: data.user_id,
                        title: data.title,
                        txtFName: data.first_name,
                        txtLName: data.last_name,
                        txtMName: data.middle_name,
                        DobDay: data.dob_day,
                        DobMonth: data.dob_month,
                        DobYear: data.dob_yr,
                        txtPostCode: data.postcode,
                        txtHouseNumber: data.address_line1,
                        txtAddress2: data.address_line2,
                        txtAddress3: data.address_line3,
                        addressLine4: data.address_line4,
                        txtTown: data.town,
                        country: data.country,
                        txtCounty: data.county,
                        split_name: data.split_name,
                        source: data.source,
                        txtEmail: data.email,
                        txtPhone: data.phone,
                    };
    
                    // Save the updated formData to localStorage
                    localStorage.setItem("formData", JSON.stringify(updatedFormData));
                    localStorage.setItem("allFollowupData", JSON.stringify(data.followup_data));
                    localStorage.setItem("uuid", data.uuid);
                    localStorage.setItem("split_name", data.split_name);
                } else {
                    console.error("Unexpected API response:", response.data);
                }
            } catch (error) {
                console.error("API fetch error:", error);
            }
        };
    
        const storedFormData = getStoredFormData();
    
        // Fetch data if formData is missing or empty
        if (!storedFormData || Object.keys(storedFormData).length === 0) {
            console.log("formData is missing or empty. Fetching from API...");
            fetchDataFromAPI();
        }
    }, []); // Empty dependency array ensures this runs only once on component mount
    
    const handlebtnChange = (otp) => {
        setOTP(otp);
        if (otp.length == 6) {
            setError(false);
        }
    };

    const handleSubmit = async (e) => {
        setBtnDisabled(true);
        if (otp.length !== 6) {
            setError(true);
            setBtnDisabled(false);
            return;
        } else {
            const res = await getCreditAnalysisDataV2(
                uuid,
                formData,
                "submit_otp",
                { referenceID, otp }
            );


            if (res.data.response.status !== "Success") {
                setIsInvalid(true);
                setOtpshow(false);
                setTimeout(() => history.push(redirectUrl), 3000);
            } else {
                history.push(redirectUrl);
            }
        }
    };

    const handleTimeout = async () => {
        const skippedLeadsResponse = await skippedLeads(
            "OTP_timeout",
            (uuid),
            localStorage.getItem("split_name"));
        history.push(redirectUrl);
    };

    useEffect(() => {
        if (timeRemaining === 0) {
            handleTimeout();
            return;
        }

        const id = setInterval(() => {
            setTimeRemaining((prevTime) => {
                if (prevTime > 0) {
                    return prevTime - 1;
                }
                clearInterval(id);
                return 0;
            });
        }, 1000);
        return () => clearInterval(id);
    }, [timeRemaining]);

    const resendOTP = async (e) => {
        setTimeRemaining(60);
        setResendDiv(true);
        setTimeout(() => {
            setResendDiv(false);
        }, 5000);
        const res = await getCreditAnalysisDataV2(
            localStorage.getItem("uuid") ?? visitorParameters.visitor_parameters.uuid,
            formData,
            "resend_otp",
            { referenceID }
        );
    };

    return (
        <>
            <div className="OTP-Page">
                <section className="otp-section">
                    <div className="container">
                        <div className="brand">
                            <div className="logo pt-4 mb-5">
                                <img src={TMSlogo} height={60} alt="Logo" />
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row justify-content-md-center">
                            <div className="col-lg-6">
                                <div
                                    className={`card w-100 otp-card screen3 all-screen p-4 ${otpshow ? "show" : "hide"}`}
                                >
                                    <div className="card-body text-white">
                                        <img
                                            src={SecurityImg}
                                            className="img-fluid mt-4 mb-3"
                                            alt="Security Icon"
                                        />
                                        <h3 className="text-center">Enter Your OTP</h3>
                                        <p className="text-center">
                                            We’ve sent a <strong>6-digit</strong> code to your registered
                                            <strong> mobile number</strong>. Please enter it below to verify your identity.
                                        </p>
                                        <div className="form-group otp-feilds mb-3">
                                            <OtpInputBox
                                                length={6}
                                                onChange={handlebtnChange}
                                                className="form-control"
                                                id="otp"
                                            />
                                        </div>
                                        {error && (
                                            <span className="error_msg mt-2">
                                                Please enter a valid OTP
                                            </span>
                                        )}
                                        <div className="form-group mb-2">
                                            <button
                                                disabled={btnDisabled}
                                                className="otp-verify-btn"
                                                id="verify-otp"
                                                onClick={handleSubmit}
                                            >
                                                Verify OTP
                                            </button>
                                        </div>
                                        <div className="re-function d-flex justify-content-center">
                                            <p className="t-remaing">
                                                <a>Time Remaining : <span>{timeRemaining}</span>s</a>
                                            </p>
                                            {/* <p className="r-otp">
                                                <a onClick={resendOTP}>
                                                    Resend OTP
                                                </a>
                                            </p> */}
                                        </div>
                                        <div>
                                            <p className={`text-center ${resendDiv ? "show" : "hide"}`}>
                                                OTP resend!
                                            </p>

                                        </div>
                                        <div className="scure-label mb-3">
                                            <img src={SecureLabel} className="img-fluid" alt="Secure Label" />
                                            <p className="m-0">
                                                Your security is our priority. This verification step ensures your account remains safe.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <OTPSuccess show={isValid} />
                                <OTPFail show={isInvalid} />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default CreditCheck_OTP_flp;
